module.exports = __webpack_public_path__ + "img/dcu30-char-4.16de318d.png";